// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2u2oj","left":"StickyBox_left__3lt7d","right":"StickyBox_right__2bczD"};